import { Measurement } from './Measurement';
import { Nutrient } from './Nutrient';
import { NutrientSource } from '../NutrientSource/NutrientSource';
import { IngredientMeasurementEnum } from './IngredientMeasurementEnum';
import { IngredientNutrient } from '../Nutrient/NutrientUnit';

// type NutrientKey = "energy" | "fat" | "saturatedFattyAcids" | "transFattyAcids" |
//   "cholesterol" | "sodium" | "carbohydrate" | "fibre" | "sugars" | "protein" |
//   "vitaminD" | "vitaminC" | "potassium" | "calcium" | "iron" | "addedSugars" |
//   "sugarAlcohols" | "monounsaturatedFats" | "polyunsaturatedFats" | "omega3" | "omega6" |
//   "caffeine" | "ash" | "water" | "moisture" |
//   // sugar alcohols
//   "erythritol" | "isomalt" | "mannitol" | "xylitol" | "lactitol" |
//   "sorbitol" | "maltitol" | "unspecifiedSugarAlcohol";
//
// type IngredientNutrientMap = { [key in NutrientKey]: Nutrient };

export type Ingredient = {
    id: number;
    foodCode:string;
    name: string;
    weightInGrams: number;
    allMeasurements: Measurement[];
    unitOfMeasurement: IngredientMeasurementEnum;
    quantityInUnitOfMeasurement: number;
    hasVolumeUnitOfMeasurement: Boolean;
    additionalNutrients: Nutrient[];
    nutrientSource?: NutrientSource | null;
    nutrients: {
      [key: string]: {
        category: string,
        ingredientNutrient: IngredientNutrient
      };
    };
    brand: string | null;
    components: string | null;
    measurement?: Measurement;
    categoryDensityId: number|null;
    subIngredients?: string;
    createdOn: Date | null;
    updatedOn: Date | null;
    createdUserName: string | null;
    updatedUserName: string | null;
    supplierName: string | null;
};

/**
 * Creates a new ingredient with all properties set to their default values
 * TODO: Allow v-ingredient-nutrient-quantity-input-row to handle the default values instead
 *
 * @returns An object representing the default ingredient state
 */
export function createDefaultIngredient(): Ingredient {
  return {
    id: 0,
    foodCode: "",
    name: "",
    brand: "",
    components: "",
    allMeasurements: [],
    additionalNutrients: [],
    weightInGrams: 100,
    nutrients: {},
    unitOfMeasurement: 1,
    quantityInUnitOfMeasurement: 100,
    hasVolumeUnitOfMeasurement: false,
    categoryDensityId: null,
    createdOn: null,
    updatedOn: null,
    createdUserName: null,
    updatedUserName: null,
    supplierName: null
  };
}